import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromRunDates from './+state/run-dates/run-dates.reducer';
import { RunDatesEffects } from './+state/run-dates/run-dates.effects';
import { RunDatesService } from './services/run-dates.service';
import { RunDatesFacade } from './+state/run-dates/run-dates.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromRunDates.RUN_DATES_FEATURE_KEY,
      fromRunDates.runDatesReducer
    ),
    EffectsModule.forFeature([RunDatesEffects]),
  ],
  providers: [RunDatesService, RunDatesFacade],
})
export class RunDatesStoreModule {}
